'use client';

import React from 'react';
import { TerrainOverview } from '@/components/resort/TerrainDetailed';
import { TrailMap } from '@/components/resort/TrailMap';
import { SidebarAd } from '@/tracking/ads/components/SidebarAd';
import { RouteAndAnalyticsProps } from '@/page-components/pathTypes';
import { IResortLayout } from '@/page-components/resort/_layout';
import {
  IDescriptionsResort,
  IRelatedNews,
  IResortPageInfo,
  IResortPathInfo,
  IResortTrailmapPage,
} from '@/api/resort/types';
import { Main } from '@/components/resort/Layout/Main';
import { Side } from '@/components/resort/Layout/Side';
import { RegularAd } from '@/tracking/ads/components/RegularAd';
import PlanYourTrip from '@/components/common/PlanYourTrip/ResortWidget';
import RelatedArticles from '@/components/resort/RelatedArticles';
import { Hero400Error } from '@/components/400';
import { TotalLifts } from '@/components/resort/TotalLifts';
import { SkiGptPromotion } from '@/components/common/SkiGptPromotion';
import { PageBody } from '@/components/common/PageBody';

export type ResortTrailmapPageProps = {
  resort: IResortPageInfo,
  trailmap: IResortTrailmapPage | null,
  pathInfo: IResortPathInfo,
  resortDescriptionTabs: Array<IDescriptionsResort>,
  relatedNews: IRelatedNews | null,

} & RouteAndAnalyticsProps & IResortLayout;

export const DEBUG_TAG = 'resort-trailmap-page';
export const TEMPLATE_ID = '3.2.3';
export const TEMPLATE_NAME = 'Resort Trailmap';
export default function ResortTrailmapPage({
  resort,
  trailmap,
  pathInfo,
  resortDescriptionTabs,
  relatedNews,
}: ResortTrailmapPageProps) {
  const resortCountry = resort?.region?.country_code;

  if (!resort) {
    return <Hero400Error light />;
  }

  return (
    <>
      <Main>
        <PageBody>
          {trailmap && (
            <TrailMap
              trailMap={trailmap.trailMap}
              resort={pathInfo}
              descriptionTabs={resortDescriptionTabs}
            />
          )}
          {trailmap && (
            <div>
              <TerrainOverview
                data={trailmap}
                pathInfo={pathInfo}
                resortCountry={resortCountry}
              />
              <TotalLifts lifts={trailmap.lifts} />
            </div>
          )}
          <SkiGptPromotion
            templateId={TEMPLATE_ID}
            name={resort.title}
          />
          <PlanYourTrip
            resort={pathInfo}
            hasSkiRental={pathInfo.hasSkiRental}
            hasFlights={pathInfo.hasFlights}
            hasCarRental={pathInfo.hasCarRental}
            liftsUrl={resort.liftsUrl}
            rentalUrl={resort.rentalUrl}
            lessonsUrl={resort.lessonsUrl}
            isPartner={resort.isPartner}
            resortCountry={resortCountry}
          />
          <RegularAd isFirst />
        </PageBody>
      </Main>
      <Side>
        <RelatedArticles
          relatedNewsList={relatedNews}
        />
        <SidebarAd id={pathInfo.uuid} />
      </Side>
      {/* JSON-LD renders from the RSC page (see app/.../trailmap/page.tsx). */}
    </>
  );
}

// fetchProps moved to ./trailmap.server.ts so the App Router RSC page can
// import the data fetcher without pulling in this 'use client' bundle.
